import { Box, Typography } from '@mui/material';
import { ComparePlansButton } from '../../components/pay-wall/ComparePlansButton';

export type LandingAppFeaturePartPosition = 'left' | 'right';

type LandingAppFeatureProps = {
  image: string;
  title: string;
  description: string;
  position?: LandingAppFeaturePartPosition;
};

export const LandingAppFeature = ({ image, title, description, position = 'left' }: LandingAppFeatureProps) => (
  <Box display="flex" flexDirection={position === 'left' ? 'row' : 'row-reverse'} gap={10}>

    <Box flex='1' flexBasis='50%' justifyContent={'center'} display='flex'>
      <img src={image} style={{ height: '100%', width: '100%', maxHeight: 800, objectFit: 'contain' }} />
    </Box>

    <Box flex="1" sx={{
      p: 6,
      display: 'flex',
    }}
      flexBasis='50%'
      justifyContent={'center'}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 500 }}>
        <Typography sx={{ typography: 'h6' }} gutterBottom>{title}</Typography>
        <Typography sx={{ typography: 'body1' }} gutterBottom>{description}</Typography>
        <ComparePlansButton />
      </Box>
    </Box>
  </Box>
);
